import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  activeReport: "896",
    // activeReport: JSON.parse(localStorage.getItem("dashboardKey")) || 0,
}

export const dashboardActiveReport = createSlice({
    name: 'dashboardActive',
    initialState,
    reducers: {
        setActiveReport: (state, action) => {
        state.activeReport = action.payload
        localStorage.setItem("dashboardKey", JSON.stringify(action.payload));
        },
    },
})
export const { setActiveReport } = dashboardActiveReport.actions
export default dashboardActiveReport.reducer